import { EstateSignUp } from '@/modules/estate/models/EstateSignUp';
import { EstateSignUpFinancialAdvisorMeta } from '@/modules/estate/models/meta/EstateSignUpFinancialAdvisorMeta';
import { EstateSignUpMetaType } from '@/modules/estate/constants/EstateSignUpMetaType';

type MetaType = EstateSignUpFinancialAdvisorMeta;

export class EstateSignUpMeta {
  static factory(model: Partial<EstateSignUp>): MetaType | null {
    switch (model.metaType) {
      case EstateSignUpMetaType.ESTATE_SIGN_UP_FINANCIAL_ADVISOR_META:
        return EstateSignUpFinancialAdvisorMeta.mapModel({ ...model.meta });
      default:
        return null;
    }
  }
}
